import axios from "axios";
import { STORAGE_KEYS } from "./constants";

/* "Remember session" keeps the token in localStorage, otherwise sessionStorage. */
export const getToken = () =>
  localStorage.getItem(STORAGE_KEYS.token) || sessionStorage.getItem(STORAGE_KEYS.token);

export const clearToken = () => {
  localStorage.removeItem(STORAGE_KEYS.token);
  sessionStorage.removeItem(STORAGE_KEYS.token);
};

export const saveToken = (token, remember) => {
  clearToken();
  (remember ? localStorage : sessionStorage).setItem(STORAGE_KEYS.token, token);
};

const toError = (error) => {
  if (!error.response) {
    return {
      status: 0,
      message:
        error.code === "ECONNABORTED"
          ? "The server took too long to respond, please try again"
          : "Unable to reach the server, please check your connection",
    };
  }
  const { status, data } = error.response;
  return {
    status,
    code: data?.code,
    message: data?.message || "Something went wrong, please try again",
    errors: data?.errors,
  };
};

// Same hard deadline as the other Denzo staff apps, so a dropped connection
// can't leave a request (and the UI waiting on it) hanging forever.
export const REQUEST_TIMEOUT_MS = 15000;

const config = {
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: { Accept: "application/json" },
  timeout: REQUEST_TIMEOUT_MS,
};

export const apiClient = axios.create(config);

apiClient.interceptors.request.use((request) => {
  const token = getToken();
  if (token) request.headers.Authorization = `Bearer ${token}`;
  return request;
});

apiClient.interceptors.response.use(
  (res) => res,
  (error) => {
    const err = toError(error);
    // A 403 tagged joborder_access means the module was switched off or the
    // user lost the Job Order role; a plain 403 is just one refused action.
    if (err.status === 401 || (err.status === 403 && err.code === "joborder_access")) {
      clearToken();
      const reason = err.status === 403 ? `?reason=${encodeURIComponent(err.message)}` : "";
      window.location.replace(`/login${reason}`);
    }
    return Promise.reject(err);
  }
);

/* Unauthenticated calls (login, forgot password, SSO exchange) — never redirects. */
export const apiAuth = axios.create(config);
apiAuth.interceptors.response.use((res) => res, (error) => Promise.reject(toError(error)));
